import { createWebHistory, createRouter } from 'vue-router'
import { DOCUMENT_TITLE_PREFIX } from '@/libs/constants'
import { getSiteInfo, getAuthToken } from '@/libs/auth-helper'

// Static imports for main routes
import MainView from '@/views'
import LoginView from '@/views/Login'
import MemberView from '@/views/member'
import MenuPreview from '@/demo/MenuPreview.vue'
import { registerMenus } from '@/demo/api.cjs'
import { menuNames } from '@/demo/menus.cjs'

// Member routers
import { dash } from './dash'
import user from './user'
import partner from './partner'
// import bet from "./bet";
import { bet } from './bet'
import board from './board'
import reports from './reports'
import settings from './settings'
import admin from './admin'
import { cashBoth } from './cash'
import game from './game'
// const routeMembers = [user, casino,slot,minigame, company, partner, cashBoth, reports, board, point, settings];
const routeMembers = [dash, partner, user, bet, cashBoth, reports, game, board, settings, admin]
// Keep the original menu definitions; unconnected pages are explicitly labelled sample previews.
const connectedPages = ['dashboard', 'userList', 'userDetail', 'userDetailView', 'betGameTotal', 'usertotalList']
function preparePreview (route, group) {
  const menuText = menuNames[route.meta.code]
  route.meta = { ...route.meta, code: menuText ? route.meta.code : undefined, text: menuText || route.meta.text }
  if (route.children && route.children.length) {
    route.children.forEach(child => preparePreview(child, group))
    route.redirect = { name: (route.children.find(child => child.meta.code) || route.children[0]).name }
  } else if (!connectedPages.includes(route.name)) {
    route.component = MenuPreview
    route.meta = { ...route.meta, demoGroup: group }
  }
}
routeMembers.forEach(route => preparePreview(route, route.name))
registerMenus(routeMembers)

const routes = [
  {
    path: '/',
    name: 'main',
    component: MainView,
    meta: {
      layout: 'default',
      guest: true
    },
    redirect: 'login'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      layout: 'login',
      guest: true,
      bodyClass: 'loginBody'
    }
  },
  {
    path: '/member',
    name: 'member',
    component: MemberView,
    meta: {
      guest: false
    },
    redirect: 'dash',
    children: routeMembers
  }
]
// console.log(routes);
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior () {
    return { top: 0, left: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (!to.meta.guest && !getAuthToken()) return next('/login')
  if (!to.matched.length) return next('/dash')
  let title = DOCUMENT_TITLE_PREFIX
  const siteInfo = getSiteInfo()
  if (siteInfo) {
    title = siteInfo.siteId
  }
  document.title = title
  next()
})

export default router
